import ReferencData from "../../../common/ShareFun/ReferencData";

export const SAVE_CLIENT_SERVICES = 'SAVE_CLIENT_SERVICES';
export const SET_RELOCATION_PLAN_ALTERNATE_CONTACT = 'SET_RELOCATION_PLAN_ALTERNATE_CONTACT';
export const SET_CASE_TRANSFEREE_DETAILS = 'SET_CASE_TRANSFEREE_DETAILS';
export const SET_RELOCATION_PLAN_DEPENDANT_DETAILS = 'SET_RELOCATION_PLAN_DEPENDANT_DETAILS';
export const SET_RELATED_ROLES = 'SET_RELATED_ROLES';

export function saveClientServices(clientServices) {
    return {
        type: SAVE_CLIENT_SERVICES,
        data: clientServices
    }
}

export function saveTransfereeDetails(transfereeDetails) {
    return setItem(SET_CASE_TRANSFEREE_DETAILS, transfereeDetails);
}

function setItem(type, data) {
    return {
        type: type,
        data: data,
    }
}

// AlternateContact
export function setRelocationPlanAlternateContact(relocation) {
    return dispatch => {
        // check if relocationPlanAlternateContact is empty object
        if (Object.entries(relocation.relocationPlanAlternateContact).length === 0) {
            const url = 'api/OrderDetailService/RetrieveRelocationPlanAlternateContact';
            const relocationPlanId = sessionStorage.getItem("RelocationPlanId");
            ReferencData.RetrieveRelocationPlanSteps(relocationPlanId, url)
                .then(res => {
                    if (res.Successful) {
                        dispatch(setItem(SET_RELOCATION_PLAN_ALTERNATE_CONTACT, res.RelocationPlanDetails))
                    }
                })
        }
    }
}

// relocation roles related to PartyRelatedRoleID of DependantIDs
export function fetchRelatedRoles(relocation) {
    return dispatch => {
    if (relocation.relatedRoles.length === 0) {
        ReferencData.RetrieveRelatedRoles()
            .then(res => {
                dispatch(setItem(SET_RELATED_ROLES, res))
            })
    }
    }
}

// caseTransfereeDetails
// Session["caseTransfereeId"] = iResult["CaseRelocationDetails"]["TransfereeID"].ToString();
export function setCaseTransfereeDetails(relocation) {
    return dispatch => {
        // check if relocationPlanAlternateContact is empty object
        if (Object.entries(relocation.caseTransfereeDetails).length === 0) {
            const url = 'api/TransfereeDetailService/RetrieveTransfereeGeneralDetails';
            const caseTransfereeId = sessionStorage.getItem("caseTransfereeId");
            ReferencData.RetrieveRelocationPlanSteps(caseTransfereeId, url)
                .then(res => {
                    if (res.Successful) {
                        dispatch(saveTransfereeDetails(res.TransfereeDetails));
                    }
                })
        }
    }
}

export function fetchRelocationPlanDependantDetails(relocation) {
    return dispatch => {
        if (Object.entries(relocation.relocationPlanDependantDetails).length === 0) {
            const url = "api/OrderDetailService/RetrieveRelocationPlanDependantDetails";
            const relocationPlanId = sessionStorage.getItem("RelocationPlanId");
            ReferencData.RetrieveRelocationPlanSteps(relocationPlanId, url)
                .then(res => {
                    dispatch(setItem(SET_RELOCATION_PLAN_DEPENDANT_DETAILS, res.RelocationPlanDependant));
                })
        }
    }
}

// RetrieveGenderTypes